import {useTranslation} from 'react-i18next';
import {useCallback, useState} from 'react';
import i18n, {Callback, TFunction} from 'i18next';

export function useLocalization(ns: string[] = []) {
    const {t} = useTranslation(ns);
    const [currentLanguage, setCurrentLanguage] = useState<string>(localStorage.getItem('i18n-lng'));

    const changeLanguage = useCallback((lng?: string, callback?: Callback) => {
        if (lng && lng !== currentLanguage) {
            localStorage.setItem('i18n-lng', lng);
            setCurrentLanguage(lng);
        }

        return i18n.changeLanguage(lng, callback);
    }, [currentLanguage]);

    const rawT = useCallback((key: string, ...params) => {
        if (!key) {
            return '';
        }

        return t(key.toString().toLowerCase(), ...params);
    }, [t]);

    return {t: rawT as TFunction, changeLanguage, currentLanguage};
}
